import { BrowserModule } from '@angular/platform-browser';
import {NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { CoreModule } from './modules/core/core.module';
import { BerakningshjalpenModule } from './modules/berakningshjalpen/berakningshjalpen.module';
import { BFFModule } from './modules/bff/bff.module';
import { registerLocaleData } from '@angular/common';

import localeSe from '@angular/common/locales/se-SE';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ServerErrorInterceptor } from './modules/core/interceptors/server-error.interceptor';
import { CacheInterceptor } from './modules/core/interceptors/cache.interceptor';

import { Webkit2AngularModule } from '@skv/skv-webkit2angular';
import { Icon } from '@skv/skv-webkit-icon';

const namespace = 'klient';
Icon.register(namespace);

registerLocaleData(localeSe, 'se');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CoreModule,
    AppRoutingModule,
    BerakningshjalpenModule,
    BFFModule,
    Webkit2AngularModule
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true}
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {
}
